import { Accessor, JSX, Match, Setter, Show, Switch } from "solid-js";
import { useModal } from "../modal";
import { RedeemCodeModal } from "../redeem_code_modal";
import { PhosphorIcon } from "~/widgets/icons";
import { HeaderCoinsPill } from "./coins_pill";
import { BrandingRow, HubbleBranding } from "~/widgets/branding";
import { useWebStoreContext } from "~/context/webstore_context";

// this component uses the webstore context to refresh the coins balance
// hence it should be used only in the webstore context (routes inside (web_store) folder)
export function CoinsPillOrBranding(props: {
  mode: string;
  showCoins?: Accessor<boolean> | undefined;
  userName?: string;
  coins: number;
  isRedeemCodeEnabled?: boolean;
  showBranding?: boolean;
  showVerticalBranding?: boolean;
  isClientAxis?: boolean;
  buildBranding?: () => JSX.Element;
  showRedeemCodeCta?: boolean;
}) {
  const { openModal } = useModal()!;
  const { refreshV4HomePage, webstoreUIConfig } = useWebStoreContext();

  return (
    <div class="flex flex-row items-center gap-2">
      <Show
        when={
          webstoreUIConfig().showHubbleBranding &&
          !(props.showCoins?.() ?? true)
        }
      >
        <Switch>
          <Match when={props.showBranding}>
            {props.buildBranding?.() ?? (
              <Show
                when={props.showVerticalBranding}
                fallback={<BrandingRow />}
              >
                <HubbleBranding
                  verticalOrientation={props.showVerticalBranding}
                  class={`w-fit border-0 ${props.isClientAxis ? "pt-2" : ""}`}
                />
              </Show>
            )}
          </Match>
          <Match when={props.showRedeemCodeCta}>
            <button
              class={`flex h-8 w-fit flex-col items-center justify-center rounded-full bg-baseDark px-3 py-3 text-f12Bold text-baseTertiaryLight lg:h-9 lg:text-mediumBold`}
              onClick={() => {
                openModal(() => {
                  return (
                    <RedeemCodeModal
                      userName={props.userName ?? ""}
                      refreshV4HomePage={refreshV4HomePage}
                    />
                  );
                }, "md:w-[416px] h-fit");
              }}
            >
              <div class="flex flex-row items-center justify-center">
                <PhosphorIcon
                  name="plus"
                  fontSize={14}
                  class="pr-1"
                  size={"bold"}
                />
                <div>Redeem code</div>
              </div>
            </button>
          </Match>
        </Switch>
      </Show>
      <Switch>
        <Match when={props.showCoins?.() ?? true}>
          <HeaderCoinsPill
            userName={props.userName}
            mode={props.mode}
            coins={props.coins}
            isRedeemCodeEnabled={props.isRedeemCodeEnabled}
          />
        </Match>
      </Switch>
    </div>
  );
}
